import { Action, Dispatch } from 'redux';
import { get } from 'components/Shared/server';
import { ConservatorySeasonProductModel } from 'models/ConservatorySeasonProductModel';

const RESPONSESTATUS_SUCCESS = 200;

export const GUIDE_SEASON_DATA_LOADING = 'GUIDE_SEASON_DATA_LOADING';
export const GUIDE_SEASON_DATA_LOADED = 'GUIDE_SEASON_DATA_LOADED';
export const GUIDE_SEASON_PRODUCT_SELECTED = 'GUIDE_SEASON_PRODUCT_SELECTED';
export const GUIDE_SEASON_VARIANT_SELECTED = 'GUIDE_SEASON_VARIANT_SELECTED';
export const GUIDE_SEASON_VALID = 'GUIDE_SEASON_VALID';
export const GUIDE_SEASON_INVALID = 'GUIDE_SEASON_INVALID';

export interface ConservatorySeasonAction extends Action {
  products: ConservatorySeasonProductModel[];
}

export interface ConservatorySeasonSelectProductAction extends Action {
  productId: string;
  season: string;
}

export interface ConservatorySeasonSelectVariantAction extends Action {
  width: number;
  depth: number;
  roofMultiple: number;
}

export const guideSeasonValid = () => ({
  type: GUIDE_SEASON_VALID
});

export const guideSeasonInValid = () => ({
  type: GUIDE_SEASON_INVALID
});

export const guideSeasonProductSelected = (productId: string, season: string) => ({
  type: GUIDE_SEASON_PRODUCT_SELECTED,
  productId,
  season
});

export const guideSeasonVariantSelected = (width: number, depth: number, roofMultiple: number) => ({
  type: GUIDE_SEASON_VARIANT_SELECTED,
  width,
  depth,
  roofMultiple
});

export const guideSeasonDataloaded = (
  makeProducts?: ConservatorySeasonProductModel[] | undefined
) => ({
  type: GUIDE_SEASON_DATA_LOADED,
  products: makeProducts
});

export const guideSeasonDataloading = () => ({
  type: GUIDE_SEASON_DATA_LOADING,
  products: undefined
});

export const guideSeasonFetchData = (articleGroup: string) => {
  return (dispatch: Dispatch) => {
    dispatch(guideSeasonDataloading());

    if (articleGroup.length < 1) {
      dispatch(guideSeasonDataloaded(undefined));
      return;
    }

    void get({ url: '/conservatory/getseasondata?artGrp=' + articleGroup })
      .then(response => {
        if (response.status !== RESPONSESTATUS_SUCCESS) {
          dispatch(guideSeasonDataloaded(undefined));
          return;
        }

        return response.json();
      })
      .then((data: ConservatorySeasonProductModel[]) => {
        dispatch(guideSeasonDataloaded(data));
      });
  };
};
